<template>
  <button
    :aria-label="displayClasses.buttonIcon"
    :class="[{ 'loading': loading }, displayClasses.spanIcon, 'Button']"
    :disabled="loading"
    @click.prevent="saveItemAction()"
  >
    <span :class="[displayClasses.buttonIcon, 'Button-icon']" />
    <span class="Shortlist-label">{{ displayClasses.label }}</span>
  </button>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
// import ModalLoginForm from '@/components/modal/modal-authentication-forms/modal-login-form.vue';

export default {
  name: 'SaveItemButton',

  components: {
    // ModalLoginForm,
  },

  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    companyId: {
      type: [Number, String],
      default: null,
    },
    companyName: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    context: {
      type: String,
      default: null,
    },
    isRegisterInterest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      animate: false,
      loading: false,
      savedItem: false,
      savedIcon: false,
      openModal: false,
      buttonIcon: 'ShortlistIcon',
      spanIcon: 'ShortlistIcon-icon',
      labelIcon: 'ShortlistIcon-label',
      label: 'Shortlist',
    };
  },
  computed: {
    ...mapState('user', {
      isLoggedIn: (state) => state.loggedIn,
    }),
    ...mapGetters('savedItems', {
      getItemSavedStatus: 'getItemSavedStatus',
    }),
    importComment() {
      switch (this.type) {
        case 'jobs':
          return 'Shortlist Job Modal';
        case 'companies':
          return 'Follow Company Modal';
        case 'reviews':
          return 'Favourite Review Modal';
        default:
          return 'Register Modal';
      }
    },
    thisItem() {
      return {
        id: this.id,
        type: this.type,
        companyId: this.companyId,
        companyName: this.companyName,
        title: this.title,
        url: this.url,
      };
    },

    displayClasses() {
      if (this.type === 'companies') {
        return {
          buttonIcon: `${this.isItemInStore ? 'fas' : 'far'} fa-thumbs-up`,
          spanIcon: 'FollowIcon-icon',
          labelIcon: 'FollowIcon-label',
          label: this.isItemInStore ? 'Saved Company' : 'Save Company',
        };
      }

      if (this.type === 'reviews') {
        return {
          buttonIcon: `${this.isItemInStore ? 'fas' : 'far'} fa-star`,
          spanIcon: 'ShortlistIcon-review',
          labelIcon: 'ShortlistIcon-label',
          label: this.isItemInStore ? 'Saved Review' : 'Save Review',
        };
      }

      if (this.isRegisterInterest) {
        return {
          buttonIcon: `RegisterInterestIcon  ${this.isItemInStore ? 'fas' : 'far'} fa-clipboard-list-check`,
          spanIcon: 'ShortlistIcon-register',
          labelIcon: 'ShortlistIcon-label',
          label: this.isItemInStore ? '' : '',
        };
      }

      return {
        buttonIcon: `${this.isItemInStore ? 'fas' : 'far'} fa-heart`,
        spanIcon: 'ShortlistIcon-icon',
        labelIcon: 'ShortlistIcon-label',
        label: this.isItemInStore ? 'Saved Job' : 'Save Job',
      };
    },

    isItemInStore() {
      // TODO Check item is in store onces endpoint available

      // Admin section does not have the saveItem store, we need to check if it exists
      if (!this.getItemSavedStatus) return false;
      return this.getItemSavedStatus(this.thisItem);
    },
  },

  created() {
    this.openModal = false;
  },

  methods: {
    ...mapActions('savedItems', {
      deleteItem: 'deleteItem',
      addItem: 'addItem',
    }),
    /**
     * Add or removes a saved item
     */
    saveItemAction() {
      this.$gtag.send({
        event: `${this.type}-icon`,
        action: 'clicked',
      });

      if (this.isRegisterInterest) {
        window.location.href = this.url;
        return false;
      }

      if (!this.isLoggedIn) {
        this.$bus.$emit('bus:save-item-modal:open-login', this.thisItem);
        this.openModal = true;
        return false;
      }

      this.animate = false;
      this.loading = true;

      if (this.isItemInStore) {
        return this.deleteItem(this.thisItem)
          .then(() => {
            this.animate = true;
            this.loading = false;

            if (this.context === 'TED') {
              this.$gtag.send({
                event: 'follow-company-removed',
                action: this.thisItem.compId,
                category: 'TED',
              });
            } else {
              this.$gtag.send({
                event: 'item-removed',
                action: this.type,
              });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }

      return this.addItem(this.thisItem)
        .then(() => {
          this.animate = true;
          this.loading = false;

          if (this.context === 'TED') {
            this.$gtag.send({
              event: 'follow-company',
              action: this.thisItem.compId,
              category: 'TED',
            });
          } else {
            this.$gtag.send({
              event: 'item-saved',
              action: this.type,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
